import React, {PureComponent} from 'react';

import {Classes, Overlay, Collapse, Button, MenuItem} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import toastr from "toastr";

import InputRegular from '../common/InputRegular';

export default class EditAlphanumericIdModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        value: '',
        fieldsCheckActive: false,
        errorsList: []
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false,
        })
    }
    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
            value: this.props.alphanumericId
        })
    }

    componentDidUpdate() {
        if (this.props.alphanumericId && this.state.value === undefined && this.props.showModal) {
            this.setState({
                value: this.props.alphanumericId
            })
        }
    }

    checkForRestrictedWords = (text) => {
        if (text) {
            //console.log('check for restrictions run')
            let arrayOfRestrictedWords = ['CIA', 'FBI', 'BIA', 'MUP', 'GOV', 'APR', 'Interpol', 'MTS', 'Telekom', 'Telecom',
                'A1', 'Telenor', 'VIP', 'MI5', 'MI6', 'WHO', 'COVID', 'COVID19', 'IRS', 'Amazon', 'AWS', 'Google', 'Gmail',
                'Yahoo', 'iCloud', 'Apple', 'Samsung', 'Bank', 'WellsFargo', 'Chase', 'Fedex', 'DHL', 'Bitcoin', 'BTC', 'XRP',
                'Ripple', 'CEX', 'CEXIO', 'WesternUnion', 'EE', 'Three', 'Vodafone', 'TMobile', 'T-Mobile', 'GDPR', 'AT&T',
                'GPS', 'GSM', 'EDGE', 'WiFi', 'PayPal', 'Amex', 'Discover', 'O2', 'Verizon', 'Police', 'Alarm', 'Payoneer',
                'VISA', 'MasterCard', 'Intesa', 'UniCredit', 'UniCreditBank', 'Twilio', 'SMS', 'Tyntec', 'Facebook',
                'Instagram', 'TikTok', 'Twitter', 'MacBook', 'Tesla', 'Vaccine', 'Hermes', 'Post', 'Mail', 'iPhone',
                'Huawei', 'Xiaomi', 'Stripe', 'JPMorgan', 'Citigroup', 'MorganStanley', 'Bancorp', 'USBank', 'Truist',
                'GoldmanSachs', 'TDGroup', 'Holding', 'EU', 'EUR', 'Euro', 'Dollar', 'Money']

            let checkResult = false;

            let textToArray = text.split(' ');

            textToArray.map(text => arrayOfRestrictedWords.map(word => word.toLowerCase() === text.toLowerCase() ? checkResult = true : ''))

            // arrayOfRestrictedWords.map(word => text.toLowerCase().includes(word.toLowerCase()) ? checkResult = true : '');

            // console.log('checkForRestrictedWords: ', text, textToArray, checkResult)

            return !checkResult
        }
    }

    handleNext = async () => {
        await this.setState({fieldsCheckActive: true, loader: true})
        let projectId = localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let anyErrorActive = false;
        this.state.errorsList.map(error => error ? anyErrorActive = true : '')
        this.checkForRestrictedWords(this.state.value)
        if (!anyErrorActive) {
            try {
                const result = await http.patch('/api/project/' + projectId + '/alphanumeric', {"alphanumeric_id": this.state.value}, {headers: {authorization: getJwt()}})
                // console.log('results: ', result)
                toastr.success('Alphanumeric Id saved successfully')
                this.props.updateUserFromServer();
                this.props.handleClose()
                this.setState({loader: false})
            } catch (e) {
                this.setState({loader: false})
                toastr.error("Alphanumeric Id wasn't saved, please try again.")
            }
        } else {
            this.setState({loader: false})
        }
    }

    handleSubmit = async () => {


        // console.log('here 1: ', anyErrorActive, this.state.errorsList)
        // await this.setState({fieldsCheckActive: false})
    }

    render() {

        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={this.state.billingDetailsOpen ? (Classes.OVERLAY_SCROLL_CONTAINER + ' padding-top-400') : Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">
                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={async () => {
                                await this.props.handleClose();
                                await this.setState({value: undefined})
                            }}><i className="fas fa-times"></i></p>
                            <h2>EDIT ALPHANUMERIC ID</h2>
                        </div>
                        {/*{console.log('Errors List: ', this.state.errorsList)}*/}
                        <div className='modal-main'>
                            <div className='margin-top-20 margin-bottom-10'>
                                <InputRegular
                                    id="1"
                                    label1="Alphanumeric Id"
                                    label2=""
                                    placeholder="Workspace Name"
                                    type='alphanumeric-id'
                                    onChange={(value) => this.setState({value})}
                                    value={this.state.value}
                                    required={true}
                                    fieldsCheckActive={this.state.fieldsCheckActive}
                                    updateErrorsList={this.updateErrorsList}
                                    errorMessage={this.checkForRestrictedWords(this.state.value) ?
                                        "All conditions are not met."
                                        :
                                        "This Sender name is not allowed. Please contact sms@emitto.io to request it."
                                    }
                                />

                            </div>

                            <p>Alphanumeric ID represents your personalised Sender ID towards your customers.<br/>
                                It can contain up to 11 characters, at least one letter (upper case A-Z, lower case
                                a-z), numbers 0-9 and spaces. No special characters are allowed.
                                Note: To send SMS to India, the Sender ID must be exactly 6 characters long.</p>


                            <div className='flex-end'>
                                <button
                                    className='btn-transparent-border margin-right-20 margin-bottom-30 margin-top-10'
                                    onClick={async () => {
                                        await this.props.handleClose();
                                        await this.setState({value: undefined})
                                    }}>Cancel
                                </button>
                                {this.state.loader ?
                                    <button className='btn-action btn-spinner margin-bottom-30 margin-top-10'
                                            disabled={true}>Save <i className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button className='btn-action margin-bottom-30 margin-top-10'
                                            onClick={this.handleNext}>Save</button>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </Overlay>
        )
    }
}